import React from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import {
  getContactsActions,
  getUserRolesAction,
} from "../../actions/UserActions";
import {
  getAllTransactionsAction,
  getAllTasksAction,
  createTaskAction,
  createAfterCareForm,
} from "../../actions/TransactionActions";
import { getVendorTransactionsAction } from "../../actions/VendorTransactionActions";
import { getBuyerTransactionsAction } from "../../actions/BuyerTransactionActions";
import {
  formatPhoneNumber,
  toastMessage,
  cryptoTokenDecode,
  getContingencyData,
  convertTimeToMinutes,
  getTimeFromMins,
  checkObjExists,
} from "../Common/Common";
import moment from "moment";
import html2pdf from "html2pdf.js";
import { addDocAction, uploadDocumentAction } from "./../../actions/DocActions";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import StickyHeader from "./StickyHeader";
import { HelpOutline } from "@material-ui/icons";
import FormActionPrompt from "./FormActionPrompt";

var _ = require("lodash");

class AfterCare extends React.Component {
  constructor(props) {
    super(props);
    var userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    this.state = {
      contacts: [],
      transactions: [],
      transaction: {},
      appointmentDate: "",
      transactionId: "",
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      showPrompt: false,
      promptType: "",
      selectedTransClientEmail: "",
      errors: {},
      showLoader: false,
    };

    this.exportFormToPDF = this.exportFormToPDF.bind(this);
  }

  componentWillMount() {
    this.getAllTransactions();
  }

  handleTransactionSelection(e) {
    if (e) {
      this.setState({
        transaction: e,
        transactionId: e.id,
        selectedTransClientEmail: e.clientEmail,
        errors: {},
      });
    }
  }

  clearTransactionSelection() {
    this.handleClosePrompt();
    this.setState({
      transaction: {},
      errors: {},
    });
  }

  handleShowPrompt(name) {
    this.setState({
      showPrompt: true,
      promptType: name,
    });
  }

  handleClosePrompt() {
    this.setState({
      showPrompt: false,
      promptType: "",
    });
  }

  getAllTransactions(id) {
    this.setState({
      showLoader: true,
    });
    if (
      this.state.userType === message.VENDOR &&
      this.state.currentRole === message.BUYERAGENT
    ) {
      this.props.getVendorTransactionsAction().then((vendorRes) => {
        this.setState({
          transactions: this.props.vendorTransactions.data || [],
          showLoader: false,
        });
      });
    } else if (
      this.state.userType === message.BUYER &&
      this.state.currentRole === message.BUYER
    ) {
      this.props.getBuyerTransactionsAction().then((buyerRes) => {
        this.setState({
          transactions: this.props.buyerTransactions.data || [],
          showLoader: false,
        });
      });
    } else {
      this.props.getAllTransactionsAction("INPROGRESS").then((res) => {
        this.setState({
          transactions: this.props.transactions.data || [],
        });
        this.setState({
          showLoader: false,
        });
      });
    }
  }

  async exportFormToPDF() {
    this.setState({
      showLoader: true,
    });
    this.handleClosePrompt();

    let form = document.getElementById("formToExport");

    let transId = this.state.transactionId;

    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();

    let clientFullName =
      this.state.transaction.clientFirstName.trim() +
      (this.state.transaction.clientLastName
        ? " " + this.state.transaction.clientLastName.trim()
        : "");

    let fileName =
      "aftercare-instructions" +
      (clientFullName ? "_" + clientFullName : "") +
      filestamp +
      ".pdf";
    let fn = fileName.split(" ").join("_");

    //Set the pdf Export Options
    let opt = {
      margin: 1.5,
      filename: fn,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2.5, width: 1000 },
      jsPDF: { unit: "in", format: "a1", orientation: "p" },
    };

    //Begin the fileupload setup
    var documents = [];
    var docDetail = {};

    //Exports the file to a blob
    const blob = await html2pdf()
      .set(opt)
      .from(form)
      .toPdf()
      .output("blob", fn);

    //Set the file details for the insert into the ducuments colection
    docDetail = {
      fileName: fn,
      size: (blob.size / (1024 * 1024)).toFixed(2),
    };
    documents.push(docDetail);

    var dataToPost = {
      transactionId: transId,
      location: "Transaction Docs",
      document: documents,
    };

    //Setup the formdata for the fileupload to s3
    var formData = new FormData();
    formData.append("file", blob, fn);

    //addDocAction writes the mongodb record about the file and returns the unique file name that will be stored in 33
    this.props.addDocAction(dataToPost).then((res) => {
      if (res.status === code.OK) {
        var fileUploadName = "";
        res.data.map((item) => {
          if (fileUploadName.length > 0) {
            fileUploadName +=
              "@@@" + item.document + "###" + item.uploadedFileName;
          } else {
            fileUploadName = item.document + "###" + item.uploadedFileName;
          }
          //uploadDocumentAction actually sends the file to S3
          this.props
            .uploadDocumentAction(formData, transId, undefined, fileUploadName)
            .then((isValidDoc) => {
              // console.log("VALID");
              //Export the file for download
              html2pdf().set(opt).from(form).save();
              this.setState({
                showLoader: false,
              });
            });
        });
      } else {
        this.setState({
          showLoader: false,
        });
        //console.log("BAD addDocAction Status: " + res.status);
        toastMessage(code.ERROR, res.data);
      }
    });
  }

  sendForm(transId) {
    this.setState({
      showLoader: true,
    });
    this.handleClosePrompt();

    let newEventStart = moment();
    let newEventEnd = moment();
    let newEventTime = convertTimeToMinutes(
      moment(newEventStart).get("hour") +
        ":" +
        moment(newEventStart).get("minutes")
    );

    let newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [
        "Aftercare Instructions for @client_firstname @client_lastname",
      ],
      communicationTo: ["@client_email"],
      communicationType: "EMAIL",
      contingency: "Client",
      day: 0,
      description: [
        '<p>Hey <a href="" class="wysiwyg-mention" data-mention="" data-value="client_firstname">@client_firstname</a>, thanks for visiting us!</p><p></p><p>Your aftercare instructions are available at the link below. Just copy and paste it into your browser.</p><p></p><p>@aftercare_form_url</p><p></p><p>If you have any questions or concerns, please contact your artist, @artist_firstname @artist_lastname.</p><p></p><p>Enjoy your tattoo!</p>',
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Aftercare Form - Email",
      transactionId: transId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          this.setState({
            showLoader: false,
          });
          toastMessage(code.SUCCESS, "Form sent");
          // console.log(createEventRes);
        }
      });
    }

    newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [""],
      communicationTo: ["@client_phone"],
      communicationType: "TEXT",
      contingency: "Client",
      day: 0,
      description: [
        "Hey @client_firstname, thanks for visiting us! We emailed you aftercare instructions. If you have any questions or concerns, please contact your artist, @artist_firstname @artist_lastname. Enjoy your tattoo!",
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Aftercare Form - Text",
      transactionId: transId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          this.setState({
            showLoader: false,
          });
          // console.log(createEventRes);
        }
      });
    }

    let data = {
      transactionId: transId,
    };
    this.props.createAfterCareForm(data).then((res) => {
      if (res.status === code.OK) {
        // toastMessage(code.SUCCESS, "Form sent");
      }
    });
  }

  handleChange = (e, key) => {
    if (
      this.state.transaction &&
      Object.keys(this.state.transaction).length > 0
    ) {
      this.setState({
        transaction: {
          ...this.state.transaction,
          [key]: e.target.value,
        },
      });
    }
  };

  errorHandler(errors) {
    this.setState({
      errors: errors,
    });
  }

  render() {
    let transactions = this.state.transactions;
    let transaction = this.state.transaction;
    let listedTransactions = [];

    for (let i = 0; i < transactions.length; i++) {
      let time =
        moment(
          getContingencyData(
            transactions[i].contingencies,
            "First Appointment",
            "startDate"
          )
        ).get("hour") +
        ":" +
        moment(
          getContingencyData(
            transactions[i].contingencies,
            "First Appointment",
            "startDate"
          )
        ).get("minutes");
      let timeToMins = convertTimeToMinutes(time);
      let minsToTime = getTimeFromMins(timeToMins);

      listedTransactions.push({
        label:
          transactions[i].shortName +
          " - " +
          transactions[i].dsd.buyer[0].firstname +
          (transactions[i].dsd.buyer[0].lastname
            ? " " + transactions[i].dsd.buyer[0].lastname
            : ""),

        id: transactions[i]._id,
        clientFirstName: transactions[i].dsd.buyer[0].firstname,
        clientLastName: transactions[i].dsd.buyer[0].lastname
          ? transactions[i].dsd.buyer[0].lastname
          : "",
        clientEmail: transactions[i].dsd.buyer[0].email,
        clientPhone: transactions[i].dsd.buyer[0].mobileNumber,
        guardianName: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].firstname +
            " " +
            transactions[i].dsd.closingAgents[0].lastname
          : "",
        guardianEmail: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].email
          : "",
        guardianPhone: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].mobileNumber
          : "",
        artistName:
          transactions[i].dsd.listingAgents[0].firstname +
          " " +
          transactions[i].dsd.listingAgents[0].lastname,
        artistPhone: transactions[i].dsd.listingAgents[0].mobileNumber,
        transactionType: transactions[i].transactionType,
        description: transactions[i].dsd.heldBy,
        appointmentDate:
          moment(
            getContingencyData(
              transactions[i].contingencies,
              "First Appointment",
              "startDate"
            )
          ).format("MM/DD/YYYY") +
          " " +
          minsToTime,
        status: transactions[i].status,
        shortName: transactions[i].shortName,
        description: transactions[i].dsd.heldBy,
      });

      // console.log(listedTransactions);
    }

    return (
      <div className="admin-steps admin-content-area">
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <StickyHeader
          listedTransactions={listedTransactions}
          transaction={this.state.transaction}
          handleTransactionSelection={this.handleTransactionSelection.bind(
            this
          )}
          clearTransactionSelection={this.clearTransactionSelection.bind(
            this
          )}
          handleShowPrompt={this.handleShowPrompt.bind(this)}
          selectedTransClientEmail={this.state.selectedTransClientEmail}
          formType="aftercare"
          errorHandler={this.errorHandler.bind(this)}
        />
        <div className="container-custom">
          <Form className="form-sm form-admin" id="formToExport">
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      Aftercare Instructions
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>
                    Client First Name<span className="text-danger"> *</span>
                    :
                  </Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      this.handleChange(e, "clientFirstName")
                    }
                    value={
                      checkObjExists(transaction)
                        ? transaction.clientFirstName
                        : ""
                    }
                    isInvalid={!!this.state.errors.clientFirstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientFirstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Last Name:</Form.Label>
                  <Form.Control
                    onChange={(e) => this.handleChange(e, "clientLastName")}
                    value={
                      checkObjExists(transaction)
                        ? transaction.clientLastName
                        : ""
                    }
                    isInvalid={!!this.state.errors.clientLastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientLastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Appointment Date/Time:</Form.Label>
                  <Form.Control
                    type="text"
                    name="appointment"
                    id="appointment"
                    value={
                      checkObjExists(transaction)
                        ? transaction.appointmentDate
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Artist Name:</Form.Label>
                  <Form.Control
                    type="text"
                    name="artistName"
                    id="artistName"
                    value={
                      checkObjExists(transaction)
                        ? transaction.artistName
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
              {/* <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Artist Phone:</Form.Label>
                  <Form.Control
                    type="text"
                    name="artistPhone"
                    id="artistPhone"
                    value={
                      checkObjExists(transaction)
                        ? formatPhoneNumber(transaction.artistPhone)
                        : ""
                    }
                  />
                </Form.Group>
              </Col> */}
            </Row>
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 pt-3">DAY 1-5</h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={8}>
                <h4 className="title-small font-600 mb-3 pt-3">
                  If your tattoo is wrapped:
                </h4>
                <ul>
                  <li>Don't do anything yet</li>
                  <li>
                    Your artist will advise you how long to leave it wrapped
                    post-appointment
                  </li>
                </ul>
                <h4 className="title-small font-600 mb-3 pt-3">
                  If your tattoo is unwrapped or wrap is taken off early:
                </h4>
                <ul>
                  <li>
                    Wash your tattoo with antibacterial soap{" "}
                    <b>3 TIMES DAILY</b>
                  </li>
                  <li>
                    Lightly dab it dry and let air dry for{" "}
                    <b>5-10 MINUTES</b>
                  </li>
                  <li>Apply a light layer of ointment after washing</li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      DAY 5-14
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={8}>
                <ul>
                  <li>
                    Wash your tattoo with antibacterial soap{" "}
                    <b>2 TIMES DAILY</b>
                  </li>
                  <li>
                    Apply <b>UNSCENTED</b> lotion as needed
                  </li>
                  <li>
                    <b>DON'T</b> scratch or pick at your tattoo while it's
                    healing
                  </li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      Questions? Concerns? Please contact your artist!
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>

        <FormActionPrompt
          transaction={this.state.transaction}
          promptType={this.state.promptType}
          showPrompt={this.state.showPrompt}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          sendForm={this.sendForm.bind(this)}
          handleClosePrompt={this.handleClosePrompt.bind(this)}
          clearTransactionSelection={this.clearTransactionSelection.bind(
            this
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    transactions: state.reducer.transactions,
    vendorTransactions: state.reducer.vendorTransactions,
    buyerTransactions: state.reducer.buyerTransactions,
    tasks: state.reducer.tasks,
  };
};

export default connect(mapStateToProps, {
  addDocAction,
  uploadDocumentAction,
  getAllTransactionsAction,
  getVendorTransactionsAction,
  getBuyerTransactionsAction,
  getContactsActions,
  getUserRolesAction,
  getAllTasksAction,
  createTaskAction,
  createAfterCareForm,
})(AfterCare);
